import {
   KEY_REFERENCE_TITLE,
   NO_PARTNER_REFS,
   NO_SFTP_REFS,
   NO_SYNC_REFS,
   NO_TRANS_REFS,
   partnerRefLabel,
   sftpRefLabel,
   syncRefLabel,
   transRefLabel,
} from 'common/strings';
import Panel from 'components/Panel';
import ReferenceItems from 'features/layout/CommonPage/panels/ReferencesPanel/ReferenceItems';
import i18n from 'i18n';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {usePartnersRefs} from 'redux/partners/hooks/usePartnersRefs';
import {useSftpsRefs} from 'redux/sftp-user/hooks/useSftpsRefs';
import {useSynchronizationsRefs} from 'redux/synchronizations/hooks/useSynchronizationsRefs';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import {useIsPermittedByRole} from 'common/hooks/useIsPermittedByRole';
import {AdminResourceType} from 'types/diplomat/settings/adminroles/AdminResourceType';

// const NUM_REF_ROWS = 5;

const SftpReferenceItems = ({id, keyType}: {id: string; keyType: 'ssh'}) => {
   const {t} = useTranslation();
   const keyCertText = t('Key');
   const sftpReferenceLabel = sftpRefLabel(keyCertText);

   const sftpServers = useSftpsRefs(id, keyType);

   return <ReferenceItems name={sftpReferenceLabel} data={sftpServers} noData={NO_SFTP_REFS} />;
};

type KeyReferencesPanelProps = {
   id: string;
   keyType: 'pgp' | 'ssh' | 'ssl';
};
const KeyReferencesPanel = ({id, keyType}: KeyReferencesPanelProps) => {
   const keyCertText = keyType === 'ssl' ? i18n.t('Certificate') : i18n.t('Key');
   const partnerReferenceLabel = partnerRefLabel(keyCertText);
   const transReferenceLabel = transRefLabel(keyCertText);
   const syncReferenceLabel = syncRefLabel(keyCertText);

   const partners = usePartnersRefs(id, keyType);
   const transactions = useTransactionsRefs(id, keyType);
   const synchronizations = useSynchronizationsRefs(id, keyType);

   const isPermittedByRole = useIsPermittedByRole();

   return (
      <Panel name={KEY_REFERENCE_TITLE}>
         <ReferenceItems name={partnerReferenceLabel} data={partners} noData={NO_PARTNER_REFS} />
         <ReferenceItems name={transReferenceLabel} data={transactions} noData={NO_TRANS_REFS} />
         <ReferenceItems name={syncReferenceLabel} data={synchronizations} noData={NO_SYNC_REFS} />
         {keyType === 'ssh' && isPermittedByRole(AdminResourceType.enum.SFTP_SERVER) && (
            <SftpReferenceItems id={id} keyType={keyType} />
         )}
      </Panel>
   );
};

export default memo(KeyReferencesPanel);
